import { ajax as request } from '@blade/common';
export const getTaskList = (data) => request({
    url: '/api/portrait-management/api/v1/batch/task/images',
    method: 'POST',
    data
});
export const getTaskById = (id) => request({
    url: `/api/portrait-management/api/v1/batch/task/${id}`,
    method: 'GET',
});
